// Per-route overrides of the employee chrome (sidebar, topbar, announcement).
// collapseSidebar: wide pages start with the sidebar collapsed (the reader can
// still expand it). fullBleed: the page brings its own header, so the
// announcement strip and the content gap are dropped and the page fills
// everything under the topbar.
const COLLAPSE_SIDEBAR = new Set(['/org-chart', '/business-ontology']);
const FULL_BLEED = new Set(['/business-ontology']);

export function chromeFor(pathname) {
  return {
    collapseSidebar: COLLAPSE_SIDEBAR.has(pathname),
    fullBleed: FULL_BLEED.has(pathname),
  };
}
